import gql from "graphql-tag";

export const menuFragment = gql`
  fragment MenuFragment on Menu {
    id
    name
    items {
      id
    }
  }
`;

export const menuItemFragment = gql`
  fragment MenuItemFragment on MenuItem {
    category {
      id
      name
    }
    parent {
      id
      name
    }
    collection {
      id
      name
    }
    menu {
      id
    }
    id
    level
    name
    isShowName
    sortOrder
    page {
      id
      title
    }
    thumbnailUrl
    mbThumbnailUrl
    url
    cellNumber
    textColor
    isTop
    carouselBanners {
      type
      id
      title
      subtitle
      url
      pcImageUrl
      h5ImageUrl
    }
    imageBanners {
      type
      id
      title
      subtitle
      url
      pcImageUrl
      h5ImageUrl
    }
  }
`;

// GraphQL does not support recurive fragments
export const menuItemNestedFragment = gql`
  ${menuItemFragment}
  fragment MenuItemNestedFragment on MenuItem {
    ...MenuItemFragment
    children {
      ...MenuItemFragment
      children {
        ...MenuItemFragment
        children {
          ...MenuItemFragment
          children {
            ...MenuItemFragment
            children {
              ...MenuItemFragment
              children {
                ...MenuItemFragment
              }
            }
          }
        }
      }
    }
  }
`;

export const menuDetailsFragment = gql`
  ${menuItemNestedFragment}
  fragment MenuDetailsFragment on Menu {
    id
    items {
      ...MenuItemNestedFragment
    }
    name
  }
`;
